import lazyPage from '@monorepo/deprecated/core/hoc/lazyPage'

export default () => ({
  path: '/about-us',
  component: lazyPage(() =>
    import('App/View/AboutUs').then(({ AboutUs }) => AboutUs)
  ),
  exact: true,
})
